"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FakeCustomMetadataClient {
    uploadCustomMetadataCsv(_) {
        return this.errorMessage
            ? Promise.reject(this.errorMessage)
            : Promise.resolve('Data has been successfully imported!');
    }
    setErrorMessage(errorMessage) {
        this.errorMessage = errorMessage;
    }
    clear() {
        this.errorMessage = undefined;
    }
}
exports.default = FakeCustomMetadataClient;
//# sourceMappingURL=FakeCustomMetadataClient.js.map